import { getConfig } from '../providers/index.js'

export function ifNotInteger(value: number | undefined, name: string): void {
	if (value === undefined) return
	if (Number.isInteger(value)) return
	getConfig().logForDebugging(`${name} should be an integer, got ${value}`, {
		level: 'warn',
	})
}
